'use strict';

import * as util from '../util/Common.js';
import {Point2D} from '../util/Geometry.js';
import * as domUtil from '../util/Dom.js';

const privateMap = util.createPrivateMapper();

export class Resizer {
  constructor(domEl, targetDomEl, options) {
    const pv = privateMap(this);
    
    options = options ? options : {};
    const baseSize = new Point2D();
    const basePosition = new Point2D();
    const position = new Point2D();
    pv.max = new Point2D(Infinity, Infinity);
    pv.min = new Point2D(0, 0);
    const verticalResize = !!options.vertical ? domUtil.emptyFunction : function(v){
      domUtil.setHeight(targetDomEl, Math.min(pv.max.y, Math.max(v, pv.min.y)));
    };
    const horizontalResize = !!options.horizontal ? domUtil.emptyFunction : function(v){
      domUtil.setWidth(targetDomEl, Math.min(pv.max.x, Math.max(v, pv.min.x)));
    };
    const mousemoveHandler = function(ev){
      position.x = ev.clientX;
      position.y = ev.clientY;
      const delta = position.sub(basePosition);
      horizontalResize(baseSize.x + delta.x);
      verticalResize(baseSize.y + delta.y);
      domUtil.dispatchEvent(targetDomEl, 'ui.resize', {
        detail: domUtil.getSize(targetDomEl)
      });
    };
    const mouseupHandler = function(ev){
      domUtil.removeEventListener(window, 'mousemove', mousemoveHandler);
      domUtil.removeEventListener(window, 'mouseup', mouseupHandler);
    };

    domUtil.addEventListener(domEl, 'mousedown', function(ev){
      ev.preventDefault();
      baseSize.copy(domUtil.getSize(targetDomEl));
      basePosition.x = ev.clientX;
      basePosition.y = ev.clientY;
      domUtil.addEventListener(window, 'mousemove', mousemoveHandler);
      domUtil.addEventListener(window, 'mouseup', mouseupHandler);
    });
    domUtil.addEventListener(domEl, 'click', domUtil.preventDefaultHandler)
  }

  get max(){
    return privateMap(this).max;
  }
  get min(){
    return privateMap(this).min;
  }
}
